/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useState, useEffect } from 'react';

export const useFirstScrollDetected = (skip: boolean = false) => {
  const [scrolled, setScrolled] = useState(skip);

  useEffect(() => {
    if (skip) {
      return;
    }
    const handleScroll = () => {
      setScrolled(true);
      window.removeEventListener('scroll', handleScroll);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [skip]);

  return scrolled;
};
